export const newTimesheet = {
  // Timesheet Tabs
  CREATING_TIMESHEET: "Skapa tidrapport",
 REPORTS: "Fakturerad tidrapport",
  WORKED_HOURS: "Arbetade timmar",
  
  // Timesheet Header
  TIMESHEET_RECORDS: "Tidrapportregister",
  SEARCH: "Sök",
  CLIENT: "Klient",
  ALL_CLIENTS: "Alla klienter",
  SELECT_CLIENT: "Välj kund",
  DATE: "Datum",
  INVOICE_BY_TIMESHEET: "Fakturera per tidrapport",
  ADD_RECORD: "Lägg till post",
  TIMESHEET_RECORD: "Tidrapportpost",
  TIME_OFF_ABSENSE: "Ledighet / Frånvaro",
  
  // Add Timesheet Sidebar
  ADD_TIMESHEET_RECORD: "Lägg till tidrapportpost",
  NO_CLIENTS_FOUND: "Inga klienter hittades",
  CLIENT_DETAILS: "Klientuppgifter",
  TASK_DETAILS: "Uppgiftsdetaljer",
  ENTER_TASK_DETAILS: "Ange uppgiftsdetaljer",
  FROM_DATE: "Från datum",
  TO_DATE: "Till datum",
  CLOCK_IN_TIME: "Instämplingstid",
  CLOCK_OUT_TIME: "Utstämplingstid",
  PRICING_TYPE: "Pristyp",
  PRICE: "Pris",
  ENTER_VALUE: "Ange värde",
  CANCEL: "Avbryt",
  SUBMIT: "Skicka",
  LOADING: "Laddar...",
  HOURSS: "Timmar",
  
  // Pricing Types
   HOURLY: "Betalning per timme",
  HOURLY_WAGES: "Betalning per timme",
  PAYMENT_PER_DAY: "Betalning per dag",
  PAYMENT_PER_WEEK: "Betalning per vecka",
  PAYMENT_PER_MONTH: "Betalning per månad",
  PAYMENT_PER_AGREED: "Betalning per överenskommelse",
  
  // Timesheet Table
  TASK_DETAILS_HEADER: "Uppgiftsdetaljer",
  PRICE_HEADER: "Pris",
  HOURS_HH_MM: "Timmar (hh:mm)",
  HOLIDAY: "Semester",
  YES: "Ja",
  NO: "Nej",
  ENTER_TASK_DETAILS_PLACEHOLDER: "Ange uppgiftsdetaljer",
  
  // Week Group
  WEEK: "Vecka",
  CUSTOMER: "Kund",
  
  // Pagination
  PREVIOUS: "Föregående",
  NEXT: "Nästa",
  
  // Time Off Sidebar
  ADD_TIME_OFF_RECORD: "Lägg till ledighetpost",
  TIME_OFF_TYPE: "Ledighettyp",
  TIME_OFF_PRICING: "Ledighetsprissättning",
  CURRENCY: "Valuta",
  PRICING: "Prissättning",
  HOURS_FOR_DAY: "Timmar per dag",
  
  // Invoice By Timesheet Modal
  INVOICE_BY_TIMESHEET_TITLE: "Faktura per tidrapport",
  SELECT_CUSTOMER_PLACEHOLDER: "Välj kund",
  SELECT_MONTH: "Välj månad",
  SELECT_YEAR: "Välj år",
  JANUARY: "Januari",
  FEBRUARY: "Februari",
  MARCH: "Mars",
  APRIL: "April",
  MAY: "Maj",
  JUNE: "Juni",
  JULY: "Juli",
  AUGUST: "Augusti",
  SEPTEMBER: "September",
  OCTOBER: "Oktober",
  NOVEMBER: "November",
  DECEMBER: "December",
  
  // Filter Header
  LOAD: "Ladda",
  SAVE: "Spara",
  CONFIRM_SAVE: "Bekräfta spara",
  ARE_YOU_SURE_SAVE_TIMESHEET: "Är du säker på att du vill spara tidrapporten?",
  SAVING: "Sparar...",
  CONFIRM_EDIT: "Bekräfta redigering",
  ARE_YOU_SURE_SAVE_CHANGES: "Är du säker på att du vill spara ändringarna?",
  
  // Validation & Messages
  NO_DATA_AVAILABLE: "Ingen data tillgänglig",
  SELECT_DATES_ABOVE: "Välj datum ovan",
  ENTER_SERVICE_NAME: "Ange tjänst",
  SEARCH_SELECT_SERVICE: "Sök & välj tjänst",
  UNITS: "Enheter",
  ENTER_UNITS: "Ange enheter",
  
  // Service Types (RUT/ROT)
  BUILD: "Bygg",
  ELECTRICITY: "El",
  GLASS_SHEET_METAL: "Glas & Plåt",
  SOIL_DRAINAGE: "Mark & Dränering",
  PAINTING_WALLPAPERING: "Målning & Tapetsering",
  PLUMBING: "VVS",
  MASONRY: "Murning",
  
  // Common
  SERVICE: "Tjänst",
  TIME: "Tid",
  SUBTOTAL: "Delsumma",
  DISCOUNT: "Rabatt",
  DATE_S_HEADER: "Datum",
  ADD_NEW_ROW: "Lägg till ny rad",
  TIM: "Tim",
  DAG: "Dag",
  VECKA: "vecka",
  M: "m",
  A: "a",
  
  // Worked Hours Page
  FROM: "Från",
  TO: "Till",
  MONTHLY_CALENDAR_SUMMARY: "Månatlig kalendersammanfattning",
  SERIAL_NO: "Serienummer",
  USER_ID: "Användar-ID",
  ABSENCES: "Frånvaro",
  HOURS: "Timmar",
  ISSUED_DATE: "Utfärdandedatum",
  ACTION: "Åtgärd",
  PREV: "Föreg",
  
  // Timesheet Reports
  SHARED_REPORTS: "Fakturerad tidrapport",
  BULK_ACTION: "Massåtgärd",
  EXPORT_SELECTED: "Exportera valda",
  DELETE_SELECTED: "Ta bort valda",
  SHARE_SELECTED: "Dela valda",
  NO_REPORTS_FOUND: "Inga rapporter hittades",
  DOWNLOAD: "Ladda ner",
  DELETE: "Ta bort", 
  // Delete Confirmation
  CONFIRM_DELETE: "Bekräfta borttagning",
  ARE_YOU_SURE_DELETE_ENTRY: "Är du säker på att du vill ta bort den här posten?",
  DELETING: "Tar bort...",
  
  // API Response Messages
  SUCCESS: "Framgång",
  TIMESHEET_SAVED_SUCCESSFULLY: "Tidrapport sparades framgångsrikt",
  FAILED_TO_SAVE_TIMESHEET: "Det gick inte att spara tidrapport",
  FAILED_TO_FETCH_TIMESHEET: "Det gick inte att hämta tidrapport",
  FAILED_TO_FETCH_EMPLOYEE_WORKING_HOURS: "Det gick inte att hämta anställdas arbetstimmar",
  TIMESHEET_ENTRY_DELETED_SUCCESSFULLY: "Tidrapportpost raderades framgångsrikt",
  FAILED_TO_DELETE_TIMESHEET_ENTRY: "Det gick inte att radera tidrapportpost",
  WORKING_HOUR_DELETED_SUCCESSFULLY: "Denna arbetstid raderades framgångsrikt",
  TIMESHEET_UPDATED_SUCCESSFULLY: "Tidrapport uppdaterades framgångsrikt",
  FAILED_TO_UPDATE_TIMESHEET: "Det gick inte att uppdatera tidrapport",
  TIMESHEET_WORKING_HOUR_UPDATED: "Tidrapport arbetstid uppdaterades",
  SOMETHING_WENT_WRONG: "Något gick fel",
  FAILED_TO_FETCH_TIMESHEET_REPORT: "Det gick inte att hämta tidrapportrapport",
  
  // Validation Error Messages
  CUSTOMER_REQUIRED: "Kund är obligatorisk",
  TASK_DETAILS_REQUIRED: "Uppgiftsdetaljer är obligatoriska",
  TASK_DETAILS_MAX_42_CHARACTERS: "Uppgiftsdetaljer kan inte överstiga 42 tecken",
  TASK_DETAILS_LATIN_ONLY: "Endast latinska tecken är tillåtna",
  CHARACTERS: "tecken",
  FROM_DATE_REQUIRED: "Fråndatum är obligatoriskt",
  TO_DATE_REQUIRED: "Till datum är obligatoriskt",
  TO_DATE_MUST_BE_AFTER_FROM_DATE: "Till datum måste vara efter fråndatum",
  CLOCK_IN_TIME_REQUIRED: "Instämplingstid är obligatorisk",
  CLOCK_OUT_TIME_REQUIRED: "Utstämplingstid är obligatorisk",
  HOURS_REQUIRED: "Timmar är obligatoriska",
  HOURS_INVALID_FORMAT: "Ogiltigt tidsformat. Använd TT:MM",
  HOURS_MAX_23_59: "Timmar kan inte överstiga 23:59",
  PRICING_TYPE_REQUIRED: "Pristyp är obligatorisk",
  PRICE_REQUIRED: "Pris är obligatoriskt",
  PRICE_MUST_BE_POSITIVE: "Priset måste vara större än 0",
  PLEASE_SELECT_DATES: "Vänligen välj minst ett datum",
  ONLY_LATIN_CHARACTERS_ALLOWED: "Endast latinska tecken är tillåtna",
  SERVICE_DESCRIPTION_MAX_CHARS: "Maximalt 42 tecken tillåtna",
  
  // Auto Generate Items Modal
  AUTO_GENERATE_ITEMS: "Lägg till flera rader",
  AUTO_GENERATE_DESCRIPTION: "Konfigurera parametrarna för att automatiskt generera fakturarader för valda datum.",
  HOURS_PER_DAY: "Timmar per dag",
  SELECT_DATES: "Välj datum",
  CLICK_TO_SELECT_DATES: "Klicka för att välja datum",
  SERVICE_DESCRIPTION: "Tjänstebeskrivning",
  ENTER_SERVICE_DESCRIPTION: "Ange tjänstebeskrivning",
  GENERATES: "Lägg till rader",
  THIS_WILL_DISPLAY_ON_INVOICE: "Detta kommer att visas på fakturan",
  
  // Tooltips
  PRICING_TYPE_TOOLTIP: "Välj hur din prissättning beräknas — till exempel baserat på tid eller en fast avgift.",
  HOURS_PER_DAY_TOOLTIP: "Ange antalet timmar du vanligtvis arbetar per dag för detta projekt.",
  HOURLY_PRICE_TOOLTIP: "Ställ in det belopp du tar betalt per arbetstimme.",
  DATES_TOOLTIP: "Ange datumen när arbetet utfördes.",
  CALENDAR_TOOLTIP: "Klicka för att välja ett datum. Dra för att välja flera datum.",
  SERVICE_DESCRIPTION_TOOLTIP: "Beskriv din tjänst (max 42 tecken). Endast latinska tecken är tillåtna (A-Z, a-z, 0-9, mellanslag och vanlig interpunktion).",
  
  // Timesheet Filter Header
  FROMS: "Från",
  TO: "Till",
  DD_MM_YYYY: "dd/mm/åååå",
  LOAD: "Ladda",
  SAVE_TIMESHEET: "Spara tidrapport",
  
  // Invoice by Timesheet Modal
  CREATE_INVOICE_BY_TIMESHEET: "Skapa faktura per tidrapport",
  INVOICE_MODAL_DESCRIPTION: "Vänligen ange nedanstående uppgifter så uppdateras din faktura därefter.",
  SUBMITTING: "Skickar...",
  
  // Invoice by Timesheet Modal Validation
  CLIENT_REQUIRED: "Klient är obligatorisk",
  PLEASE_FILL_ALL_REQUIRED_FIELDS: "Vänligen fyll i alla obligatoriska fält",
  DATE_IS_REQUIRED: "Datum är obligatoriskt",
  NO_TIMESHEET_WORKING_HOURS_FOUND: "Inga tidrapport arbetstimmar hittades. Vänligen skapa och spara tidrapport arbetstimmar först, sedan skapa faktura.",
 REMOVE_FREELANCER_TITLE: "Ta bort frilansare från denna kollektiva faktura?",
  REMOVE_FREELANCER: "Ta bort frilansare",
  CONFIRM_REMOVE_FREELANCER_MESSAGE: "Att ta bort <strong>{{name}}</strong> från denna kollektiva faktura kommer att radera all deras fakturaaktivitetsdata här (datum, timmar, rabatter).<br/><br/>Detta kan inte ångras. Fortsätta?",
  CANCEL_BUTTON: "Avbryt",
  REMOVE_FREELANCER_BUTTON: "Ta bort frilansare",
  NO_CANCEL: "Nej, Avbryt",
  YES_REMOVE: "Ja, Ta bort",
  
  // Unsaved Timesheet Warning Modal
  UNSAVED_TIMESHEET_WARNING_TITLE: "Spara nya arbetsrader",
  UNSAVED_TIMESHEET_CONFIRMATION_MESSAGE: "Du har osparade ändringar i din tidrapport. Vill du spara innan du fortsätter?",
  UNSAVED_TIMESHEET_CANCEL_BUTTON: "Nej, spara inte och fortsätt",
  UNSAVED_TIMESHEET_SAVE_CONTINUE_BUTTON: "Spara och fortsätt",
  SAVING: "Sparar...",
  
  // Deduction Page
  DEDUCTIONS_LABEL: "Avdrag",
  DEDUCTION_DESCRIPTION: "Här är alla avdrag som gjorts via fakturor skapade genom Invozio.",
  INVOICED: "Fakturerad",
  NOT_INVOICED: "Inte fakturerad",
  ALL_MONTHS: "Alla månader",
  ALL_YEARS: "Alla år",
  ALL_CUSTOMERS: "kunder",
  ADD_DEDUCTION: "Lägg till utlägg",
  NOT_INVOICED_DEDUCTIONS: "Inte fakturerade avdrag",
  NOT_INVOICED_DESCRIPTION: "Detta avsnitt visar avdrag som ännu inte har fakturerats.",
  DEDUCTIONS: "Avdrag",
  PERIOD: "Period",
  NOT_INVOICED_STATUS: "Inte fakturerad",
  EDIT: "Redigera",  SELECT_CUSTOMER: "Välj kund",
  
  // Deduction Toast Messages
  DEDUCTION_CREATED_SUCCESSFULLY: "Avdrag skapades framgångsrikt",
  DEDUCTION_UPDATED_SUCCESSFULLY: "Avdrag uppdaterades framgångsrikt",
  DEDUCTION_SUBMIT_FAILED: "Det gick inte att skicka avdrag",
  "timeSheetBtnTutorial":"Se hur man loggar arbetstimmar i ett tidrapporteringssystem och genererar en faktur",
};
